import { $find, $findAll, $qs, $setCss } from 'fxdom/es';
import { each, go } from 'fxjs/es';
import { NessUtilF } from '../../../Ness/Util/F/Function/module/NessUtilF.js';
import { NessLabsConstantS } from '../../S/Constant/module/NessLabsConstantS.js';

/**
 * 이미지 프리로드
 * @param {HTMLElement} container 컨테이너 요소
 */
const preloadImages = (container) => {
  const slides = Array.from($findAll('.character-item img', container));
  const images = slides.map(
    (img) =>
      new Promise((resolve) => {
        if (img.complete) resolve();
        else {
          img.onload = () => resolve();
          img.onerror = () => resolve();
        }
      }),
  );
  return Promise.all(images);
};

/**
 * 스크롤 필요 여부 계산
 */
const calculateNeedsScroll = ({ container, character_length }) => {
  const { width: item_width } = go(container, $find('.swiper-slide')).getBoundingClientRect();
  const per_slide_width = item_width + NessLabsConstantS.SLIDE_ITEM_GAP;
  // + NessLabsConstantS.SLIDE_SIDE_PADDING;
  return per_slide_width * character_length - NessLabsConstantS.SLIDE_ITEM_GAP > container.clientWidth;
};

const makeBraekPoints = (need_scroll) => {
  // maxSlides
  // 1280 이하로 브라우저가 줄어들었을때 아이템 너비 줄어들지 않기 위해서 사용
  return need_scroll
    ? {
        1920: {
          slidesPerView: 10,
          maxSlides: 10,
          enabled: true,
          slidesPerGroup: 4,
        },
        1440: {
          slidesPerView: 9,
          maxSlides: 9,
          enabled: true,
          slidesPerGroup: 4,
        },
        1280: {
          slidesPerView: 8,
          maxSlides: 8,
          enabled: true,
          slidesPerGroup: 4,
        },
        1279: {
          slidesPerView: 'auto',
          enabled: true,
          slidesPerGroup: 4,
          roundLengths: true,
        },
      }
    : {};
};
/**
 * Swiper 옵션 생성
 */
const createSwiperOptions = ({ characters, container, is_mobile, needs_scroll }) => {
  const character_length = characters.length;
  const items = Array.from($findAll('.character-item', container));
  const activeIndex = items.findIndex((item) => item.classList.contains('active'));
  return {
    on: {
      init: function () {
        go(container, $findAll('.nav-container'), each($setCss({ opacity: 1 })));
        $setCss({ opacity: 1 }, container);

        if (is_mobile && !needs_scroll) go(container, $find('.swiper-wrapper'), $setCss({ gap: '8px' }));
      },
    },

    // 반응형
    breakpoints: is_mobile ? {} : makeBraekPoints(needs_scroll),

    // 네비게이션
    navigation: {
      nextEl: '.nav-btn.next',
      prevEl: '.nav-btn.prev',
      hideOnClick: true,
      disabledClass: 'swiper-button-disabled',
    },

    // 이미지 로딩
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 4,
      loadOnTransitionStart: true,
    },

    // 슬라이드 설정
    initialSlide: activeIndex,
    spaceBetween: is_mobile && !needs_scroll ? 0 : 8,
    slidesPerView: 'auto',
    slidesOffsetBefore: is_mobile && needs_scroll ? 24 : 0,
    slidesOffsetAfter: is_mobile && needs_scroll ? 24 : 0,
    slidesPerGroup: is_mobile ? 1 : Math.min(Math.max(character_length - 1, 1), 4),

    // 기타 설정
    watchOverflow: true,
    observer: true,
    observeParents: true,
    grabCursor: true,
    touchRatio: 0.7,
    threshold: 10,
    centeredSlidesBounds: true,
    centerInsufficientSlides: !needs_scroll,
  };
};

/**
 * Swiper 초기화
 */
const initializeSwiper = (options) => {
  const swiper_container = $qs('.character-swiper');
  swiper_container.style.opacity = '0';
  const swiper = new Swiper('.character-swiper', options);
  requestAnimationFrame(() => {
    swiper_container.style.opacity = '1';
  });

  return swiper;
};

export const init = async () => {
  const { characters } = box();
  const is_mobile = NessUtilF.isMobile();
  const container = $qs('.character-list');

  await preloadImages(container);

  const needs_scroll = calculateNeedsScroll({
    container,
    character_length: characters.length,
  });

  const options = createSwiperOptions({
    characters,
    container,
    is_mobile,
    needs_scroll,
  });

  initializeSwiper(options);
};
